module.exports = __webpack_public_path__ + "static/media/img_default_en.1f6504e0.jpg";